import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { LicenseAvatarModule } from '@portal-core/licenses/components/license-avatar/license-avatar.module';
import { LicenseConnectorsModule } from '@portal-core/licenses/components/license-connectors/license-connectors/license-connectors.module';
import { LicenseOpenAIFormModule } from '@portal-core/licenses/components/license-open-ai-form/license-open-ai-form.module';
import { LicenseOverviewModule } from '@portal-core/licenses/components/license-overview/license-overview.module';
import { LicenseProfileComponent } from '@portal-core/licenses/components/license-profile/license-profile.component';
import { LicenseSecurityFormModule } from '@portal-core/licenses/components/license-security-form/license-security-form.module';
import { LicenseSettingsFormModule } from '@portal-core/licenses/components/license-settings-form/license-settings-form.module';
import { LicenseSlackFormModule } from '@portal-core/licenses/components/license-slack-form/license-slack-form.module';
import { LicenseSsoFormModule } from '@portal-core/licenses/components/license-sso-form/license-sso-form.module';
import { LicenseSubscriptionModule } from '@portal-core/licenses/components/license-subscription/license-subscription.module';
import { ProfileTabModule } from '@portal-core/profiles/directives/profile-tab/profile-tab.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';

@NgModule({
  declarations: [
    LicenseProfileComponent
  ],
  imports: [
    CommonModule,
    LicenseAvatarModule,
    LicenseOverviewModule,
    LicenseSecurityFormModule,
    LicenseSettingsFormModule,
    LicenseSlackFormModule,
    LicenseSsoFormModule,
    LicenseOpenAIFormModule,
    LicenseConnectorsModule,
    MatListModule,
    MatSidenavModule,
    MatTabsModule,
    MatIconModule,
    SwitchBoardModule,
    ProfileTabModule,
    LicenseSubscriptionModule
  ],
  exports: [
    LicenseProfileComponent
  ]
})
export class LicenseProfileModule { }
